import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FiInfo } from 'react-icons/fi';
import './../Styles/History.css';
import AppHeader from './AppHeader';
import AcknowledgmentButton from './AcknowledgmentButton';
import OneToOneButton from './OneToOneButton';
const apiUrl = process.env.REACT_APP_API_URL;

const History = ({ embedded = false }) => {
    const [submittedGoals, setSubmittedGoals] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [employeeInfo, setEmployeeInfo] = useState({ full_name: '', job_title: '', employee_number: '' });

    const [acknowledgedStatus, setAcknowledgedStatus] = useState({});
    const [oneToOneStatus, setOneToOneStatus] = useState({});
    const [goals, setGoals] = useState([]);
    const [infoGoal, setInfoGoal] = useState(null);
    
    // Fetching employee information and submitted goals on component load
    useEffect(() => {
        const fetchEmployeeInfo = async () => {
            const employeeId = localStorage.getItem('employeeId'); // Getting employee ID from local storage
            if (!employeeId) {
                console.error('Employee ID not found in local storage.');
                return;
            }
            try {
                const response = await axios.get(`${apiUrl}/api/employee-info/${employeeId}`); // API call to fetch employee info
                setEmployeeInfo(response.data); // Setting employee info
            } catch (error) {
                console.error('Error fetching employee info:', error);
            }
        };

        const fetchSubmittedGoals = async () => {
            setIsLoading(true); // Setting loading state
            const employeeId = localStorage.getItem('employeeId'); // Getting employee ID from local storage
            if (!employeeId) {
                console.error('Employee ID not found in local storage.');
                setIsLoading(false);
                return;
            }
            try {
                const response = await axios.get(`${apiUrl}/api/submitted-goals/${employeeId}`); // API call to fetch submitted goals
                setSubmittedGoals(response.data); // Setting the submitted goals data
                  // Set acknowledgment statuses
                   // Now fetch the acknowledgment status from the employee_reviews table
                  const quartersResponse = await axios.get(`${apiUrl}/api/available-quarters/${employeeId}`);
                  const quarters = quartersResponse.data; // List of dynamic quarters
        
                 const acknowledgmentStatuses = {};
                 const oneToOneStatuses = {};
        
                 // Now fetch acknowledgment statuses per quarter
                 for (const quarter of quarters) {
                      const reviewsResponse = await axios.get(`${apiUrl}/api/employee-reviews/${employeeId}/${quarter}`);
                      const review = reviewsResponse.data[0]; // Assuming one review per quarter
                    
                     
            // Log the entire review object
            console.log(`Full review data for ${quarter}:`, review);
            
            if (review) {
                // MongoDB stores acknowledge as Boolean (true/false),
                // not as a MySQL tinyint (1/0), so compare directly.
                const isAcknowledged = review.acknowledge === true;
                
                console.log(`Acknowledged value for ${quarter}:`, review.acknowledge, `(boolean)`);
                
                if (isAcknowledged) {
                    acknowledgmentStatuses[quarter] = 1; // Mark as acknowledged
                } else {
                    acknowledgmentStatuses[quarter] = 0; // Default to not acknowledged
                }
                oneToOneStatuses[quarter] = Boolean(review.one_to_one_requested === true || review.one_to_one_status === 'requested');
            } else {
                acknowledgmentStatuses[quarter] = 0; // Default to 0 if no review found
                oneToOneStatuses[quarter] = false;
                console.warn(`No review found for ${quarter}. Defaulting to acknowledgment status 0.`);
            }
        }
        
        setAcknowledgedStatus(acknowledgmentStatuses); // Set acknowledgment statuses in state
        setOneToOneStatus(oneToOneStatuses);
        console.log("Acknowledgment statuses: ", acknowledgmentStatuses); // Log for debugging
            } catch (error) {
                console.error('Error fetching submitted goals:', error);
            }
            setIsLoading(false); // Stopping the loading state
        };

        fetchEmployeeInfo();
        fetchSubmittedGoals();
    }, []);

    // Update acknowledgment status locally when acknowledgment is made
     const handleAcknowledged = (quarter) => {
        setAcknowledgedStatus((prevStatus) => ({
            ...prevStatus,
            [quarter]: true,
        }));
    };

    const handleOneToOneRequested = (quarter) => {
        setOneToOneStatus(prev => ({
            ...prev,
            [quarter]: true
        }));
    };

    const updateAcknowledgedState = (goalId) => {
        setAcknowledgedStatus((prevStatus) => ({
            ...prevStatus,
            [goalId]: true, // Mark this quarter as acknowledged
        }));
    };
    

    // Function to group goals by quarter and render them as horizontal cards
    const renderQuarterCards = () => {
        const quarterGroups = submittedGoals.reduce((acc, goal) => {
            const quarter = goal.quarter;
            if (!acc[quarter]) {
                acc[quarter] = {
                    goals: [],
                    reviewer_comment: goal.reviewer_comment,
                    manager_comment: goal.manager_comment,
                    final_rating: goal.final_rating,
                    reviewer_rating: goal.reviewer_rating 
                };
            }
            acc[quarter].goals.push(goal);
            return acc;
        }, {});

        if (Object.keys(quarterGroups).length === 0) {
            return (
                <div className="pms-empty-state">
                    <p>No submitted goals found.</p>
                </div>
            );
        }

        return (
            <div className="quarter-cards-container">
                {Object.keys(quarterGroups).map((quarter) => {
                    const { goals, reviewer_comment, manager_comment, final_rating, reviewer_rating } = quarterGroups[quarter];

                    const isMainManager = localStorage.getItem('isMainManager') === '1' || localStorage.getItem('isMainManager') === 1 || Boolean(employeeInfo?.is_main_manager);
                    return (
                        <div key={quarter} className="quarter-card">
                            <h2 className="quarter-card-title">{quarter}</h2>
                            
                            <div className="history-table-wrapper">
                                <table className="history-table">
                                    <thead>
                                        <tr>
                                            <th>Goal Description</th>
                                            <th>Self Assessment</th>
                                            <th>Attachments</th>
                                            <th>Communicated</th>
                                            <th>Self Rating</th>
                                            <th>Date Submitted</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {goals.map((goal) => (
                                            <tr key={goal._id}>
                                                <td>
                                                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                                                        <span>{goal.goal_name || goal.goal_description}</span>
                                                        <button
                                                            type="button"
                                                            className="goal-info-btn"
                                                            onClick={() => setInfoGoal(goal)}
                                                            title="View Goal Details"
                                                            aria-label="View Goal Details"
                                                        >
                                                            <FiInfo size={15} />
                                                        </button>
                                                    </div>
                                                </td>
                                                <td>{goal.self_assessment}</td>
                                                <td>
                                                    {goal.attachments ? (
                                                        <a href={goal.attachments} target="_blank" rel="noopener noreferrer">
                                                            View Attachment
                                                        </a>
                                                    ) : 'No Attachment'}
                                                </td>
                                                <td>
                                                    <span className={`pms-badge ${goal.communicated ? 'pms-badge-success' : 'pms-badge-warning'}`}>
                                                        {goal.communicated ? 'Yes' : 'No'}
                                                    </span>
                                                </td>
                                                <td>{goal.self_rating}</td>
                                                <td>{new Date(goal.submitted_at).toLocaleString()}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="quarter-review-section">
                                <div className="quarter-review-details">
                                    <div className="final-rating-container">
                                        <span className="final-rating-label">Manager Rating:</span>
                                        <span className="final-rating-value">{final_rating || 'N/A'}</span>
                                    </div>
                                    <div className="reviewer-comment-box">
                                        <strong>Manager Comment: </strong>{manager_comment || reviewer_comment || 'No comment provided.'}
                                    </div>
                                </div>

                                <div className="quarter-buttons">
                                    <AcknowledgmentButton
                                        employeeId={employeeInfo.employee_number}
                                        goalId={goals[0].id}
                                        reviewerComment={reviewer_comment}
                                        finalRating={final_rating}
                                        acknowledged={Boolean(acknowledgedStatus[quarter] === 1 || acknowledgedStatus[quarter] === true)}
                                        quarter={quarter}
                                        onAcknowledged={(goalId) => {
                                            handleAcknowledged(quarter);
                                            updateAcknowledgedState(goalId);
                                        }}
                                    />
                                    <OneToOneButton
                                        employeeId={employeeInfo.employee_number}
                                        quarter={quarter}
                                        isRequested={oneToOneStatus[quarter] === true}
                                        isAcknowledged={Boolean(acknowledgedStatus[quarter] === 1 || acknowledgedStatus[quarter] === true)}
                                        isMainManager={Boolean(isMainManager)}
                                        isButtonEnabled={Boolean(final_rating !== null && final_rating !== undefined && final_rating !== '')}
                                        onRequested={handleOneToOneRequested}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <div className="history-container pms-page">
            {!embedded && (
                <AppHeader 
                    title="SUBMITTED GOALS" 
                    employeeInfo={employeeInfo}
                    centerOnly={true}
                />
            )}

            <main className="history-body pms-main">
                {isLoading ? (
                    <p>Loading...</p>
                ) : (
                    renderQuarterCards()
                )}
            </main>

            {/* Goal Information Pop-up Modal */}
            {infoGoal && (
                <div className="pms-overlay modal-overlay" onClick={() => setInfoGoal(null)}>
                    <div 
                        className="pms-modal modal-content goal-info-modal" 
                        onClick={(e) => e.stopPropagation()}
                        style={{ 
                            maxWidth: '520px', 
                            width: '92%', 
                            padding: '24px 28px', 
                            borderRadius: '10px',
                            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.2), 0 10px 10px -5px rgba(0, 0, 0, 0.1)'
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '18px', borderBottom: '1px solid var(--border, #e2e8f0)', paddingBottom: '12px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <div style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: 'rgba(234, 88, 12, 0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ea580c' }}>
                                    <FiInfo size={18} />
                                </div>
                                <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600', color: 'var(--text-primary, #0f172a)' }}>
                                    Goal Information
                                </h3>
                            </div>
                            <button
                                type="button"
                                onClick={() => setInfoGoal(null)}
                                style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: 'var(--text-secondary, #64748b)', padding: '4px', lineHeight: 1 }}
                                aria-label="Close"
                            >
                                ✕
                            </button>
                        </div>

                        <div style={{ marginBottom: '16px' }}>
                            <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', color: 'var(--text-secondary, #64748b)', marginBottom: '6px' }}>
                                Goal Name
                            </label>
                            <div style={{ fontSize: '15px', fontWeight: '600', color: 'var(--text-primary, #1e293b)', padding: '10px 14px', backgroundColor: 'var(--bg-secondary, #f8fafc)', borderRadius: '6px', border: '1px solid var(--border, #e2e8f0)' }}>
                                {infoGoal.goal_name || infoGoal.goal_description || 'Goal'}
                            </div>
                        </div>

                        <div style={{ marginBottom: '22px' }}>
                            <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', color: 'var(--text-secondary, #64748b)', marginBottom: '6px' }}>
                                Goal Description
                            </label>
                            <div style={{ 
                                fontSize: '14px', 
                                lineHeight: '1.6', 
                                color: 'var(--text-primary, #334155)', 
                                padding: '12px 14px', 
                                backgroundColor: 'var(--bg-secondary, #f8fafc)', 
                                borderRadius: '6px', 
                                border: '1px solid var(--border, #e2e8f0)',
                                maxHeight: '220px',
                                overflowY: 'auto',
                                whiteSpace: 'pre-wrap'
                            }}>
                                {infoGoal.description ? (
                                    infoGoal.description
                                ) : (
                                    <span style={{ color: 'var(--text-muted, #94a3b8)', fontStyle: 'italic' }}>
                                        No detailed description provided for this goal.
                                    </span>
                                )}
                            </div>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <button
                                type="button"
                                className="pms-btn"
                                onClick={() => setInfoGoal(null)}
                                style={{ 
                                    padding: '8px 24px', 
                                    backgroundColor: '#e67320', 
                                    borderColor: '#e67320', 
                                    color: '#ffffff', 
                                    borderRadius: '6px', 
                                    fontWeight: '600', 
                                    cursor: 'pointer' 
                                }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default History;
